import { overrideSearchForms } from '@form';

/**
 * Sets up a mutation observer to handle dynamically added content.
 * Ensures that search functionality works with asynchronously loaded elements.
 */
export function observeDynamicContent(): void {
	const observer = new MutationObserver(() => {
		overrideSearchForms();
	});

	observer.observe(document.body, {
		childList: true, // Observe direct children being added or removed
		subtree: true, // Observe changes in all descendant nodes
	});
}
